import { render, staticRenderFns } from "./SobreMi.vue?vue&type=template&id=530cb304&lang=html&"
import script from "./SobreMi.vue?vue&type=script&lang=js&"
export * from "./SobreMi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports